export function lerp(a: number, begin: number, end: number): number {
    return begin + (end - begin) * a
}
